import { render, staticRenderFns } from "./StafferManage.vue?vue&type=template&id=f2cf2d06&scoped=true&"
import script from "./StafferManage.vue?vue&type=script&lang=js&"
export * from "./StafferManage.vue?vue&type=script&lang=js&"
import style0 from "./StafferManage.vue?vue&type=style&index=0&id=f2cf2d06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cf2d06",
  null
  
)

export default component.exports